<template>
    <div class="input-group input-group-sm">
        <input type="search" name="table_search" :class="['form-control', { 'py-4': big }]" placeholder="Buscar" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :disabled="disabled"/>

        <div class="input-group-append">
            <Button type="submit" variant="default" icon="fas fa-search" :disabled="disabled" />
        </div>
    </div>
</template>


<script>
    export default {
        props: ['value', 'disabled', 'big']
    }
</script>